/** Append items that are not already in `prev`, preserving both lists' order. */
export function appendUniqueById<T extends { id: string }>(prev: T[], incoming: T[]): T[] {
  const seen = new Set(prev.map((item) => item.id));
  return [...prev, ...incoming.filter((item) => !seen.has(item.id))];
}

export function conversationListParams(opts: {
  cursor?: string | null;
  q?: string;
  channel?: 'whatsapp' | 'email';
  queue?: 'review';
  /** Mailbox email folder (#3736); the API defaults to `inbox`. */
  mailbox?: 'filtered';
}): Record<string, string> {
  const params: Record<string, string> = {};
  if (opts.cursor) params.cursor = opts.cursor;
  const query = opts.q?.trim();
  if (query) params.q = query;
  if (opts.channel) params.channel = opts.channel;
  if (opts.queue) params.queue = opts.queue;
  if (opts.mailbox) params.mailbox = opts.mailbox;
  return params;
}
